import Vue from "vue";
import Vuex from "vuex";
import { getLanguage } from "@/utils/i18n.js";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    show: false,
    titleShow: true,
    language: localStorage.getItem("language") || getLanguage() || "zh-Hans", //当前语言 以本地设置过的为主 否则判断当前手机语言 最后默认中文
  },
  mutations: {
    changeShow(state, item) {
      state.show = item;
    },
    changeTitleShow(state, item) {
      state.titleShow = item;
    },
    CHANGE_language(state, item) {
      state.language = item;
      window.localStorage.setItem("language", item);
    },
  },
  actions: {},
  modules: {},
});
